import { IPaginationReturn } from '../../interfaces/IPaginationReturn';
import { useRequest } from '../providers/useRequest';

import AppError from '../../errors/AppError';
import IEmployee from '../../interfaces/IEmployee';
import ICompany from '../../interfaces/ICompany';
import { IFilterEmployeeList } from '../../pages/collaborator/list-collaborators/CollaboratorList';

export interface IFilterEmployee {
  id?: number | null;
}
export interface IFilterCompany {
  company: ICompany | null;
}
const useCollaboratorService = () => {
  const request = useRequest<IEmployee>();
  const path = 'employee';

  const list = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    direction: 'asc' | 'desc',
    filter: IFilterEmployeeList,
  ): Promise<IPaginationReturn<IEmployee[]>> => {
    return await request
      .postAndGetManyPaginated({
        path: `${path}/list?perPage=${perPage}&currentPage=${currentPage}&orderBy=${orderField}&orderDirection=${direction}`,
        sendAuthorization: true,
        body: { ...filter },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };
  const listById = async (id: number): Promise<IEmployee> => {
    return await request
      .getOne({
        path: `${path}/${id}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listByCompanyName = async (idCompany: number): Promise<IEmployee[]> => {
    return await request
      .getMany({
        path: `${path}/findByIdCompany/${idCompany}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const create = async (employee: IEmployee): Promise<IEmployee> => {
    return await request
      .post({
        path: `${path}`,
        sendAuthorization: true,
        body: { ...employee },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const update = async (id: number, employee: IEmployee): Promise<IEmployee> => {
    return await request
      .put({
        path: `${path}/${id}`,
        sendAuthorization: true,
        body: employee,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const remove = async (id: number): Promise<void> => {
    return await request
      .remove({
        path: `${path}/${id}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return { list, listById, listByCompanyName, create, update, remove };
};

export { useCollaboratorService };
